export const normalizeMarkdownBullets = (raw?: string | null): string => {
  if (!raw) return '';
  return raw.replace(/^([ \t]*)\u2022[ \t]*/gm, '$1- ');
};
